export default __webpack_public_path__ + "static/media/dziubek.6bddf486.svg";